import moment from "moment";
export const getRangePerTimeFrame = (payinTimeFrame) => {
  const lastDate = moment("2022-12-03", "YYYY-MM-DD"); // your cutoff
  const ranges = [];

  // WEEKLY: each iso-week (Mon - Sun)
  if (payinTimeFrame === "Weekly") {
    let cursor = moment(); // now
    while (cursor.isSameOrAfter(lastDate)) {
      const start = cursor.clone().startOf("isoWeek");
      const end = cursor.clone().endOf("isoWeek");
      const range = `${start.format("YYYY-MM-DD")} - ${end.format(
        "YYYY-MM-DD"
      )}`;
      ranges.push(range);

      cursor = start.clone().subtract(1, "week");
    }
  }

  // BI-WEEKLY: non-overlapping 2-week blocks (previous week + current week),
  else if (payinTimeFrame === "Bi-Weekly") {
    // Start from "previous week" so the first block is (prev week + current week)
    let cursorStart = moment().startOf("isoWeek").subtract(1, "week");
    while (cursorStart.isSameOrAfter(lastDate)) {
      const start = cursorStart.clone().startOf("isoWeek"); // monday of first week
      const end = start.clone().add(1, "week").endOf("isoWeek"); // sunday of the next week
      const range = `${start.format("YYYY-MM-DD")} - ${end.format(
        "YYYY-MM-DD"
      )}`;
      ranges.push(range);

      // move cursor back two weeks (to previous 2-week block)
      cursorStart = start.clone().subtract(2, "weeks");
    }
  }

  // MONTHLY: calendar months
  else if (payinTimeFrame === "Monthly") {
    let cursor = moment(); // now
    while (cursor.isSameOrAfter(lastDate)) {
      const start = cursor.clone().startOf("month");
      const end = cursor.clone().endOf("month");
      const range = `${start.format("YYYY-MM-DD")} - ${end.format(
        "YYYY-MM-DD"
      )}`;
      ranges.push(range);

      cursor = start.clone().subtract(1, "month");
    }
  }

  // finalize
  return ranges;
};

export function detectRangeType(rangeStr) {
  console.log("rangeStr", rangeStr);
  const [startStr, endStr] = rangeStr.split(" - ");
  const start = moment(startStr, "YYYY-MM-DD");
  const end = moment(endStr, "YYYY-MM-DD");

  if (!start.isValid() || !end.isValid()) return "Unknown";

  const diffDays = end.diff(start, "days") + 1; // inclusive length

  if (
    start.isSame(start.clone().startOf("month"), "day") &&
    end.isSame(start.clone().endOf("month"), "day")
  ) {
    return "Monthly";
  }

  // Weekly: exactly 7 days, start Monday, end Sunday
  if (diffDays === 7 && start.isoWeekday() === 1 && end.isoWeekday() === 7) {
    return "Weekly";
  }

  // Bi-Weekly: exactly 14 days, start Monday, end Sunday
  if (diffDays === 14 && start.isoWeekday() === 1 && end.isoWeekday() === 7) {
    return "Bi-Weekly";
  }

  return "Weekly";
}

export function getApprovedStatus(endDate) {
  let end = moment(endDate).endOf("day");
  let today = moment().endOf("day");

  if (end.isAfter(today)) {
    return false;
  } else {
    return true;
  }
}
